// // import { TextField } from "@material-ui/core";
// import { Field } from "formik";
// import styled from "styled-components";


import React from 'react';
import styled from 'styled-components';

import { ErrorMessage, Field } from 'formik';
import { TextField } from '@material-ui/core';

const DefaultField = (props) => {
    const { name, type, label, variant = "outlined" } = props;

    // RETURN
    return (
        <Field
            as={TextFieldFake}
            name={name}
            helperText={<ErrorMessage name={name} component={CustomError} />}
            type={type}
            label={label}
            variant={variant}
            color="primary"
            size="small"
            fullWidth
            {...props}
        />
    );
};

export default DefaultField;

const CustomError = styled.span`
    font-size: 0.75rem;
    font-weight: 700;
    color: #D24335;
`;

const TextFieldFake = styled(TextField)`
    fieldset{
        border-color: #f0f0f0;
    }
    label{
        color: #f0f0f0;
    }
    .MuiInputBase-input{
        color: white;
    }
    svg{
        color: white;
    }
`